import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { Person } from '@emotion-icons/material/Person'
import { FlexRow } from 'src/components/flex-containers'
import { CircleImages } from 'src/v2/components/circle-images'
import { Divider, Typography } from '@mui/material'
import { FC } from 'react'

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const FooterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${Colors.neutral300};
`

type ParcelSummaryProps = {
  amountOfContacts: number
  brandIds?: string[]
}
export const ParcelSummary: FC<ParcelSummaryProps> = ({ amountOfContacts, brandIds }) => {
  return (
    <FooterContainer>
      <FooterItem>
        <FlexRow align="center" gap={Shapes.spacing[1]}>
          <Person size={16} />
          <Typography variant="text1m">{amountOfContacts}</Typography>
        </FlexRow>
      </FooterItem>
      {brandIds && (
        <>
          <Divider orientation="vertical" flexItem variant="middle" />
          <CircleImages imageUrls={[]} brandIds={brandIds} />
        </>
      )}
    </FooterContainer>
  )
}
